import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { useNavigate } from 'react-router-dom'
import './About.css'



function About() {
    const navigate = useNavigate()

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`)
    }

    return (
        <div className='about'>
            <Navbar />
            {/* About Hero Header with Construction Image */}
            <div className="about-hero-section">
                <img
                    src="/construction.webp"
                    alt="Construction site with Blitz GFRP rebars"
                    className="about-hero-background"
                />
                <div className="about-hero-overlay"></div>
                <div className="about-hero-content">
                    <p className="about-hero-tagline">About Blitz Rebars</p>
                    <h1 className="about-hero-title">Building Stronger, Smarter, Greener</h1>
                    <p className="about-hero-subtitle">
                        Blitz Fiber is a leading provider of construction materials and services, committed to delivering
                        high-performance, corrosion-free GFRP reinforcement that meets the highest standards of
                        excellence and reliability.
                    </p>
                    <div className="about-hero-buttons">
                        <button className='ContactUs'>
                            Contact Us
                        </button>
                        <button className='products'>Explore Products</button>
                    </div>
                </div>
            </div>
            <div className="aboutContainer">
                <section className="about-section about-industries">
                    <div className="about-section-header">
                        <h2 className="about-section-title">INDUSTRIES WE CATER</h2>
                        <p className="about-section-subtitle">
                            GFRP rebars engineered for durability, corrosion resistance, and long-term performance across
                            diverse infrastructure sectors.
                        </p>
                    </div>
                    <div className="about-card-grid about-card-grid-industries">

                        <div className="about-card">
                            <div className="about-card-icon">🌉</div>
                            <h3 className="about-card-title">Bridges</h3>
                            <p className="about-card-text">
                                Ideal for bridge decks, parapets, crash barriers, and coastal bridges where corrosion resistance
                                is critical.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🚆</div>
                            <h3 className="about-card-title">Railways</h3>
                            <p className="about-card-text">
                                Applied in sleepers, platforms, tunnels, and trackside infrastructure for enhanced durability.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🛣</div>
                            <h3 className="about-card-title">Roads &amp; Highways</h3>
                            <p className="about-card-text">
                                Ideal reinforcement for pavements, medians, barriers, and rigid concrete roads with long design
                                life.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🏢</div>
                            <h3 className="about-card-title">Buildings</h3>
                            <p className="about-card-text">
                                Used in residential, commercial, and high-rise structures to enhance service life and reduce
                                maintenance costs.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🏗</div>
                            <h3 className="about-card-title">Construction &amp; Infrastructure</h3>
                            <p className="about-card-text">
                                Perfect for foundations, slabs, retaining walls, and structural elements exposed to harsh
                                environments.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🚢</div>
                            <h3 className="about-card-title">Marine &amp; Shipbuilding</h3>
                            <p className="about-card-text">
                                Excellent resistance to saltwater corrosion for ports, jetties, docks, and marine structures.
                            </p>
                        </div>

                    </div>
                </section>

                {/* Products & Projects Section (after Industries We Cater) */}
                <section className="products-projects-section">
                    <div className="products-projects-inner">
                        {/* Products Header */}
                        <div className="products-header">
                            <p className="pp-kicker">Our Solutions</p>
                            <h2 className="pp-title">What we Produce</h2>
                            <p className="pp-subtitle">
                                Engineered for durability and performance across the toughest environments.
                            </p>
                        </div>

                        {/* Products Grid */}
                        <div className="pp-products-grid">
                            <div className="pp-product-card" onClick={() => handleProductClick('gfrp-rebar')} style={{ cursor: 'pointer' }}>
                                <div className="pp-product-image-wrapper">
                                    <img
                                        src="/straight.webp"
                                        alt="GFRP Rebar"
                                        className="pp-product-image"
                                    />
                                </div>
                                <div className="pp-product-body">
                                    <h3 className="pp-product-name">GFRP Rebar</h3>
                                    <p className="pp-product-description">
                                        High-strength composite reinforcing bars for concrete structures. The ultimate
                                        replacement for epoxy-coated or galvanized steel.
                                    </p>
                                    <div className="pp-specs">
                                        <h4 className="pp-specs-title">Key Specs</h4>
                                        <ul className="pp-specs-list">
                                            <li>Diameters: 6mm - 32mm</li>
                                            <li>Tensile Strength: &gt;1000 MPa</li>
                                            <li>Modulus: &gt;50 GPa</li>
                                            <li>Lengths: Up to 12m or coils</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="pp-product-card" onClick={() => handleProductClick('gfrp-mesh')} style={{ cursor: 'pointer' }}>
                                <div className="pp-product-image-wrapper">
                                    <img
                                        src="/curvedBars.webp"
                                        alt="GFRP Mesh"
                                        className="pp-product-image"
                                    />
                                </div>
                                <div className="pp-product-body">
                                    <h3 className="pp-product-name">GFRP Mesh</h3>
                                    <p className="pp-product-description">
                                        Prefabricated mesh panels for slab reinforcement, reducing on-site labour and
                                        installation time.
                                    </p>
                                    <div className="pp-specs">
                                        <h4 className="pp-specs-title">Key Specs</h4>
                                        <ul className="pp-specs-list">
                                            <li>Grid sizes: customisable</li>
                                            <li>Lightweight for easy handling</li>
                                            <li>Non-conductive and corrosion free</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="pp-product-card" onClick={() => handleProductClick('bent-bars-stirrups')} style={{ cursor: 'pointer' }}>
                                <div className="pp-product-image-wrapper">
                                    <img
                                        src="/bentBars.webp"
                                        alt="Bent Bars &amp; Stirrups"
                                        className="pp-product-image"
                                    />
                                </div>
                                <div className="pp-product-body">
                                    <h3 className="pp-product-name">Bent Bars &amp; Stirrups</h3>
                                    <p className="pp-product-description">
                                        Custom bent shapes and stirrups manufactured to project specifications for
                                        seamless site execution.
                                    </p>
                                    <div className="pp-specs">
                                        <h4 className="pp-specs-title">Key Specs</h4>
                                        <ul className="pp-specs-list">
                                            <li>Custom shapes and diameters</li>
                                            <li>High shear strength</li>
                                            <li>Engineered to design drawings</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Architect Full-width Banner */}
                        <div className="architect-banner">
                            <img
                                src="/architect.webp"
                                alt="Architect reviewing structural drawings"
                                className="architect-banner-image"
                            />
                        </div>

                        {/* Projects Header */}
                        <div className="projects-header">
                            <div>
                                <p className="pp-kicker">Our Work</p>
                                <h2 className="pp-title">Featured Projects</h2>
                            </div>
                        </div>

                        {/* Projects Grid */}
                        <div className="pp-projects-grid">
                            <div className="pp-project-card">
                                <div className="pp-project-image-wrapper">
                                    <img
                                        src="/construction.webp"
                                        alt="Coastal Highway Bridge"
                                        className="pp-project-image"
                                    />
                                    <div className="pp-project-status pp-project-status-completed">
                                        Completed
                                    </div>
                                </div>
                                <div className="pp-project-body">
                                    <div className="pp-project-meta">
                                        <span className="pp-project-location">Odisha, India</span>
                                    </div>
                                    <h3 className="pp-project-title">Coastal Highway Bridge</h3>
                                    <p className="pp-project-summary">
                                        Replacement of corroded steel reinforcement in a saltwater environment bridge
                                        deck using long-life GFRP rebars.
                                    </p>
                                    {/* <button className="pp-project-link">
                                        <span>View Details</span>
                                        <span className="pp-project-link-icon">↗</span>
                                    </button> */}
                                </div>
                            </div>


                            <div className="pp-project-card">
                                <div className="pp-project-image-wrapper">
                                    <img
                                        src="/headerBg.jpg"
                                        alt="MRI Facility Foundation"
                                        className="pp-project-image"
                                    />
                                    <div className="pp-project-status pp-project-status-completed">
                                        Completed
                                    </div>
                                </div>
                                <div className="pp-project-body">
                                    <div className="pp-project-meta">
                                        <span className="pp-project-location">Uttar Pradesh, India</span>
                                    </div>
                                    <h3 className="pp-project-title">MRI Facility Foundation</h3>
                                    <p className="pp-project-summary">
                                        Non-magnetic, non-conductive reinforcement for a sensitive hospital imaging
                                        centre foundation.
                                    </p>
                                    {/* <button className="pp-project-link">
                                        <span>View Details</span>
                                        <span className="pp-project-link-icon">↗</span>
                                    </button> */}
                                </div>
                            </div>

                            <div className="pp-project-card">
                                <div className="pp-project-image-wrapper">
                                    <img
                                        src="/upcoming.jpg"
                                        alt="High-Rise Commercial Tower"
                                        className="pp-project-image"
                                    />
                                    <div className="pp-project-status pp-project-status-upcoming">
                                        Upcoming
                                    </div>
                                </div>
                                <div className="pp-project-body">
                                    <div className="pp-project-meta">
                                        <span className="pp-project-location">Odisha, India</span>
                                        <span className="pp-project-delivery">Expected: Q3 2026</span>
                                    </div>
                                    <h3 className="pp-project-title">High-Rise Commercial Tower</h3>
                                    <p className="pp-project-summary">
                                        GFRP rebars for a multi-storey commercial complex, reducing long-term maintenance
                                        and improving durability in a coastal urban environment.
                                    </p>
                                    {/* <button className="pp-project-link">
                                        <span>View Details</span>
                                        <span className="pp-project-link-icon">↗</span>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Section 2: Specialities */}
                <section className="about-section about-specialities">
                    <div className="about-section-header">

                        <h2 className="about-section-title">SPECIALITIES</h2>
                        <p className="about-section-subtitle">
                            Our expertise lies in delivering corrosion-free, high-performance reinforcement solutions with
                            consistent quality and reliability.
                        </p>
                    </div>
                    <div className="about-card-grid">
                        <div className="about-card">
                            <div className="about-card-icon">🏭</div>
                            <h3 className="about-card-title">Manufacturing Facility</h3>
                            <p className="about-card-text">
                                State-of-the-art manufacturing unit equipped for continuous, high-volume production of GFRP
                                rebars with strict quality control at every stage.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">⏱</div>
                            <h3 className="about-card-title">On-Time Delivery</h3>
                            <p className="about-card-text">
                                Optimized production planning and logistics ensure timely dispatch and delivery, even for large
                                infrastructure projects.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">⚙️</div>
                            <h3 className="about-card-title">Customization</h3>
                            <p className="about-card-text">
                                GFRP rebars manufactured in customized diameters, lengths, surface profiles, and resin systems
                                to suit specific project requirements.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🧪</div>
                            <h3 className="about-card-title">Quality Processing</h3>
                            <p className="about-card-text">
                                Advanced pultrusion and curing processes ensure uniform fiber distribution, consistent strength,
                                and superior bond performance.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">⚖️</div>
                            <h3 className="about-card-title">Lightweight Strength Advantage</h3>
                            <p className="about-card-text">
                                High strength-to-weight ratio enables easier handling, faster installation, and reduced
                                transportation and labor costs.
                            </p>
                        </div>
                        <div className="about-card">
                            <div className="about-card-icon">🚚</div>
                            <h3 className="about-card-title">End-to-End Logistics</h3>
                            <p className="about-card-text">
                                Seamless transportation solutions from manufacturing plant to project site, ensuring safe
                                handling of non-metallic rebars.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Credibility Section */}
                <section className="about-section about-credibility">
                    <div className="about-section-header">
                        <h2 className="about-section-title">OUR CREDIBILITY</h2>
                        <p className="about-section-subtitle">
                            Our GFRP rebars are independently tested by accredited laboratories to
                            validate their mechanical performance and compliance with IRC 137:2022
                            standards. The documents below demonstrate our commitment to quality,
                            transparency, and engineering accountability.
                        </p>
                    </div>
                    <div className="credibility-documents-list">
                        {[
                            {
                                title: "IRC 137:2022 Compliance – GFRP Rebars (6 mm)",
                                description:
                                    "Independent tensile testing of 6 mm GFRP rebars conducted as per IRC 137:2022 and ASTM D7205 standards by an accredited third-party laboratory.",
                                file: "/certifications/Report_GFRP_Rebar_6mm.pdf",
                                type: "Test Report",
                            },
                            {
                                title: "IRC 137:2022 Compliance – GFRP Rebars (8 mm & 10 mm)",
                                description:
                                    "Laboratory-verified tensile strength, tensile strain, and modulus of elasticity test report for 8 mm and 10 mm GFRP rebars as per IRC 137:2022.",
                                file: "/certifications/Report_GFRP_Rebar_8mm.pdf",
                                type: "Test Report",
                            },
                            {
                                title: "Official Laboratory Issue / Reference Letter",
                                description:
                                    "Formal communication issued by the testing laboratory related to sample submission, testing reference, and report issuance for GFRP rebars.",
                                file: "/certifications/Laboratory_Issue_Letter.pdf",
                                type: "Reference Letter",
                            },
                        ].map((doc, index) => (
                            <div key={index} className="credibility-document-card">
                                <div className="credibility-document-header">
                                    <span className="credibility-document-type">{doc.type}</span>
                                    <h3 className="credibility-document-title">{doc.title}</h3>
                                </div>
                                <p className="credibility-document-description">{doc.description}</p>
                                <a href={doc.file} download className="credibility-download-link">
                                    Download PDF
                                </a>
                            </div>
                        ))}
                    </div>

                </section>






                <div className='aboveFooter'>
                    <div className="sectionHeader">
                        <p className='sectionHeading'>Need Technical Assistance or Customer Solutions?</p>
                        <p className='sectionDescription'>Our engineering team is ready to provide detailed specifications, technical consultation, and custom GFRP solutions for your specific requirements.</p>
                    </div>
                    <div className="aboveFooterContent">
                        <button className='getQuote'>Request Specifications</button>
                        <button className='download'>Contact Engineering Team</button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default About